/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { PageWrapper } from "../../../../components/page-skeleton/PageWrapper";
import { CampaignsTable } from "./CampaignsTable";
import { EmptyState } from "../../../../components/EmptyState";
import { AutoCampaignListItem } from "../models/AutoCampaign";
import { Divider } from "../../../../components/Divider";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

type Props = {
  campaigns: AutoCampaignListItem[];
};

export const CampaignsList = ({ campaigns }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Auto Campaigns"
          subtitle="Manage all of your auto campaigns"
        >
          <ButtonInternalLink to={routes.campaignsNew(organizationKeyName)}>
            Create new campaign
          </ButtonInternalLink>
        </PageHeader>
        {campaigns.length === 0 ? (
          <>
            <Divider />
            <CardBody additionalStyles={cardBodyAdditionalStyling}>
              <EmptyState
                title="No campaigns created yet"
                subtitle="Click in the top right corner to create your first new campaign."
              />
            </CardBody>
          </>
        ) : (
          <div>
            <CampaignsTable campaigns={campaigns} />
            <PageFooter>
              <StyledText className="bodyTextRegular mb-0">
                {campaigns.length}{" "}
                {campaigns.length === 1 ? "campaign" : "campaigns"} in total
              </StyledText>
            </PageFooter>
          </div>
        )}
      </CardContainer>
    </PageWrapper>
  );
};
